module.exports = __webpack_public_path__ + "static/media/vivi-comemorando-direita.2c3343e2.svg";